import { isPersistentTaskOrInstance } from 'aos-services/src/services/tasks/types/payload/BaseTaskFormPayload'
import {
    migrateTaskPayload,
    TaskFormPayload,
} from 'aos-services/src/services/tasks/types/payload/TaskFormPayload'
import {
    taskCategories,
    TaskCategory,
    translateTaskCategory,
} from 'aos-services/src/services/tasks/types/TaskCategory'
import { ChipProcess, Icon } from 'aos-ui-universal'
import React, { useCallback, useMemo } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { taskCategoryIcon, TaskOrTemplatePayload } from '../../../utils'
import { TaskFormField } from '../TaskFormField'

export const TaskCategoryField = () => {
    const { t: translate } = useTranslation()
    const { control, getValues, reset } = useFormContext<TaskOrTemplatePayload>()
    const task = useWatch({ control }) as TaskFormPayload
    const canChangeCategory = useMemo(() => !isPersistentTaskOrInstance(task), [task])

    const handleChangeCategory = useCallback(
        (category: TaskCategory) => {
            const title =
                category === TaskCategory.HBA
                    ? translate('form.category.selector.title.heavy-bird-activity', { ns: 'tasks' })
                    : category === TaskCategory.LVP
                      ? translate('form.category.selector.title.low-visibility-procedure', {
                            ns: 'tasks',
                        })
                      : undefined
            const currentTask = getValues() as TaskFormPayload
            const nextTask = {
                ...currentTask,
                category,
                title,
            } as TaskOrTemplatePayload

            if (currentTask.category !== category) {
                reset(migrateTaskPayload(currentTask, nextTask), {
                    keepDirty: false,
                    keepErrors: false,
                    keepTouched: false,
                })
            }
        },
        [getValues, reset, translate],
    )

    return (
        <Controller
            control={control}
            name='category'
            render={({ field, fieldState }) => (
                <TaskFormField
                    label={translate('form.category.label', { ns: 'tasks' })}
                    required
                    error={
                        fieldState.error
                            ? translate('create-event-modal.category.error', { ns: 'events' })
                            : undefined
                    }
                >
                    <div className='grid grid-cols-3 gap-2'>
                        {taskCategories.map(item => (
                            <ChipProcess
                                key={item}
                                layout='horizontal-2-lines'
                                className='w-full'
                                label={translateTaskCategory(translate)(item)}
                                icon={
                                    <Icon
                                        as={taskCategoryIcon[item as TaskCategory]}
                                        size={24}
                                        className='text-content-default'
                                    />
                                }
                                isSelected={field.value === item}
                                isDisabled={!canChangeCategory}
                                onPress={() => handleChangeCategory(item)}
                            />
                        ))}
                    </div>
                </TaskFormField>
            )}
        />
    )
}
